import { Component, Inject } from '@angular/core';
import { ConfigServiceInterface } from './core/services/config/config-service.interface';
import { DOCUMENT } from '@angular/common';
import { BrowserWindowRef } from './core/services/window/window.service';

@Component({
  template: '<router-outlet></router-outlet>',
  selector: 'gtd-root',
})
export class AppComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(BrowserWindowRef) private window: BrowserWindowRef,
    @Inject('ConfigServiceInterface') public configService: ConfigServiceInterface
  ) {
    const cookieHub = this.configService.cookieHub;
    if (cookieHub) {
      this.initCookieHub(cookieHub);
    }
  }

  private initCookieHub(cookieHub: string): void {
    const script = this.document.createElement('script');
    script.src = `https://cdn.cookiehub.eu/c2/${cookieHub}.js`;
    script.type = 'text/javascript';
    script.onload = () => {
      const cpm = {};
      const window = this.window.nativeWindow;
      if (window?.cookiehub && typeof window?.cookiehub?.load === 'function') {
        window.cookiehub.load(cpm);
      }
    };
    document.body.appendChild(script);
  }
}
